// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"d566c258","681":"74de2a68"}[chunkId] + ".chunk.css";
};